import PasswordIcon from '@material-ui/icons/LockOpen';
import PasswordEdit from './PasswordEdit';
export default {
    edit: PasswordEdit,
    icon: PasswordIcon,
};
